import { ItemCompleteProps } from "app/shared/components/modal/auto-complete/auto-complete";
import i18n from "app/shared/language/i18n";
import { ACCOUNT, RESPONSEDATA } from "app/shared/services/services-model.type";
import store from "app/shared/store/store";

interface ItemBankForeign {
  BANK_NODE: string;
  IMAGE: string;
  NODE_SHORTNAME: string;
  NODE_DESCRIPTION: string;
  ID_247: string;
}

interface ItemAreaForeign {
  ID: string;
  NAME: string;
}

interface ItemBranchForeign {
  BANK_NODE: string;
  NODE_DESCRIPTION: string;
  PARENT_NODE: string;
  PROVINCE_CODE: string;
  ADDRESS: string;
}

interface ItemBank247 {
  ID: string;
  NAME: string;
  NAME_VI: string;
  NAME_EN: string;
  URL: string;
  priority: string;
  Other: string;
}

interface BankForeignDataJson {
  BANK_NODE: ItemBankForeign[];
  AREA_NODE: ItemAreaForeign[];
  BRANCH_NODE: ItemBranchForeign[];
}

interface Bank247DataJson {
  BANK247: ItemBank247[];
}

let bankForeignNode: BankForeignDataJson;
let bank247Node: Bank247DataJson;

export const BRANCH_OTHER = "BRANCH_OTHER";

export function loadBankForeign() {
  return new Promise(async (resolve) => {
    if (!bankForeignNode) bankForeignNode = await import("../../../shared/util/data-json/bank-foreign.json");
    resolve(0);
  });
}

export function loadBank247() {
  return new Promise(async (resolve) => {
    if (!bank247Node) bank247Node = await import("../../../shared/util/data-json/bank-247.json");
    resolve(0);
  });
}

interface ConfigAmountProps {
  maxAmount: number;
  errorMaxDebit: string;
}

// Kiểm tra tk cùng chủ hay không;
export const findAccountSameCif = (value?: string) => {
  const listAccount = store.getState().account.LIST_ACCOUNT_PROFILE;
  if (value && value.length) {
    const filterAcc = listAccount?.ACCOUNT.filter((account) => {
      return account.ACCOUNTNO === value;
    });
    if (filterAcc && filterAcc.length) {
      return filterAcc[0];
    }
  }
  return undefined;
};

// Kiểm tra số tiền vượt hạn mức giao dịch ngày/ số dư khả dụng;
export const amountConfig = (
  accountDebit?: ACCOUNT,
  limitMain?: string,
  accountNoCredit?: string,
  notCheckLimitMain?: boolean,
): ConfigAmountProps => {
  let maxAmount = 0;
  let errorMaxDebit = "";
  let maxAvailableBalance = 0;
  const amount = accountDebit?.AVAILABLEBALANCE;
  if (amount && amount.length && typeof Number(amount) === "number") {
    maxAvailableBalance = Number(amount);
    maxAmount = maxAvailableBalance;
    errorMaxDebit = i18n.t("ACC_SO_DU_KHA_DUNG_NOT_ENOUGH");
  }
  if (!notCheckLimitMain && accountNoCredit?.length && limitMain && limitMain.length && typeof Number(limitMain) === "number") {
    const accountSameCif = findAccountSameCif(accountNoCredit);
    if (!accountSameCif) {
      if (Number(limitMain) > 0) {
        if (maxAvailableBalance > 0) {
          maxAmount = Math.min(maxAvailableBalance, Number(limitMain));
          if (maxAmount === maxAvailableBalance) {
            errorMaxDebit = i18n.t("ACC_SO_DU_KHA_DUNG_NOT_ENOUGH");
          } else {
            errorMaxDebit = i18n.t("COMMON_THONG_BAO_QUA_HAN_MUC_GD_NGAY");
          }
        } else {
          maxAmount = Number(limitMain);
          errorMaxDebit = i18n.t("COMMON_THONG_BAO_QUA_HAN_MUC_GD_NGAY");
        }
      }
    }
  }

  return { maxAmount, errorMaxDebit };
};

export const getListBankForeign = () => {
  const list: ItemCompleteProps[] = [];
  if (bankForeignNode.BANK_NODE.length) {
    bankForeignNode.BANK_NODE.forEach((item: ItemBankForeign) => {
      list.push({ value: item.BANK_NODE, label: item.NODE_DESCRIPTION, other: item.NODE_SHORTNAME, icon: item.IMAGE });
    });
  }
  return list;
};

export const getListBank247 = () => {
  const list: ItemCompleteProps[] = [];
  if (bank247Node.BANK247.length) {
    bank247Node.BANK247.forEach((item: ItemBank247) => {
      const name = i18n.language === "vi" ? item.NAME_VI : item.NAME_EN;
      list.push({ value: item.ID, label: name, icon: item.URL, other: item.Other });
    });
  }
  return list;
};

export const getListAreaForeign = () => {
  const list: ItemCompleteProps[] = [];
  if (bankForeignNode.AREA_NODE.length) {
    bankForeignNode.AREA_NODE.forEach((item: ItemAreaForeign) => {
      list.push({ value: item.ID, label: item.NAME });
    });
  }
  return list;
};

export const getListBranchForeign = (bankNode?: string, areaNode?: string) => {
  const parentNode = bankNode?.substr(2, 3);
  const listBranch = bankForeignNode.BRANCH_NODE;
  let branchFilter: ItemCompleteProps[] = [];
  if (listBranch.length && bankNode?.length && parentNode?.length && areaNode?.length) {
    listBranch.forEach((item: any) => {
      if (item.PARENT_NODE === parentNode && item.PROVINCE_CODE === areaNode) {
        branchFilter.push({ value: item.BANK_NODE, label: item.NODE_DESCRIPTION });
      }
      return;
    });
    branchFilter.push({ value: BRANCH_OTHER, label: "CHI NHANH KHAC" });
  }
  return branchFilter;
};

export const getBankForeign = (value?: string) => {
  const listBank = bankForeignNode.BANK_NODE;
  if (listBank.length && value?.length) {
    const bankFilter = listBank.filter((item: any) => {
      return item.BANK_NODE.substr(2, 3) === value;
    });
    if (bankFilter.length) return bankFilter[0];
  }
  return;
};

export const getBank247 = (value?: string) => {
  let bank: ItemCompleteProps = { value: "", label: "" };
  if (bank247Node.BANK247.length) {
    const filter = bank247Node.BANK247.filter((item: ItemBank247) => {
      return item.ID === value;
    });
    if (filter.length) {
      bank = { value: filter[0].ID, label: i18n.language === "vi" ? filter[0].NAME_VI : filter[0].NAME_EN, other: filter[0].Other };
    }
  }
  return bank;
};

export const getAreaForeign = (value?: string, listArea?: ItemCompleteProps[]) => {
  if (listArea?.length && value?.length) {
    const areaFilter = listArea.filter((item) => {
      return item.value === value.substr(0, 2);
    });
    if (areaFilter.length) return areaFilter[0];
  }
  return;
};

export const getBranchForeign = (value?: string, listBranch?: ItemCompleteProps[]) => {
  const listFilter = listBranch || [];
  if (listFilter.length && value?.length) {
    const branchFilter = listFilter.filter((item) => {
      return item.value === value;
    });
    if (branchFilter.length) return branchFilter[0];
  }
  return;
};

export const getListStock = (data?: RESPONSEDATA) => {
  const list: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("35") && indexList["35"].LIST_CONTROL_VALUE?.length) {
    indexList["35"].LIST_CONTROL_VALUE.forEach((item) => {
      list.push({ value: item.ID || "", label: item.NAME || "", other: item.Other || "" });
    });
  }
  return list;
};

export const getStockListBranch = (data?: RESPONSEDATA) => {
  const list: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("36") && indexList["36"].LIST_CONTROL_VALUE?.length) {
    indexList["36"].LIST_CONTROL_VALUE.forEach((item) => {
      list.push({ value: item.ID || "", label: item.NAME || "", other: item.Other || "" });
    });
  }
  return list;
};

export const getStock = (data?: RESPONSEDATA, value?: string) => {
  let stock: ItemCompleteProps = { value: "", label: "" };
  if (data && value?.length) {
    const indexList = data.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
    if (indexList && indexList.hasOwnProperty("35") && indexList["35"].LIST_CONTROL_VALUE?.length) {
      const banks = indexList["35"].LIST_CONTROL_VALUE.filter((item) => {
        return item.ID === value;
      });
      if (banks.length) {
        stock = {
          value: banks[0].ID || "",
          label: banks[0].NAME || "",
          other: banks[0].Other || "",
        };
      }
    }
  }
  return stock;
};

export const getBranchStock = (data?: RESPONSEDATA, value?: string) => {
  let branch: ItemCompleteProps = { value: "", label: "" };
  if (data && value?.length) {
    const indexList = data.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
    if (indexList && indexList.hasOwnProperty("36") && indexList["36"].LIST_CONTROL_VALUE?.length) {
      const branchArray = indexList["36"].LIST_CONTROL_VALUE.filter((item) => {
        return item.ID === value;
      });
      if (branchArray.length) {
        branch = {
          value: branchArray[0].ID || "",
          label: branchArray[0].NAME || "",
          other: branchArray[0].Other || "",
        };
      }
    }
  }
  return branch;
};
